export const SET_GA_LIST_INFO_VIEW = "SET_GA_LIST_INFO_VIEW"

export const setGAInfoViewList = (payload) => async (dispatch) => {
    dispatch({
        type: SET_GA_LIST_INFO_VIEW,
        payload

    })
}